import { useEffect } from "react";
import { PageHeader } from "../components/PageHeader";
import { useDocumentMeta } from "../hooks/use-document-meta";

export function LegalMentions() {
  useDocumentMeta({
    title: "Mentions légales",
    description: "Mentions légales du site Frites Dorées — grossiste alimentaire B2B spécialisé restauration rapide, basé à Aulnay-sous-Bois (93).",
    canonicalPath: "/mentions-legales",
  });
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main data-testid="legal-page" className="bg-[#050505]">
      <PageHeader kicker="Mentions légales" title="Mentions légales" />
      <section className="px-6 md:px-10 lg:px-14 py-16 max-w-3xl space-y-8 text-zinc-300 font-body leading-relaxed">
        <Block title="Éditeur du site">
          <p>Frites Dorées — Grossiste alimentaire B2B (vente en gros de produits agroalimentaires)</p>
          <p>55-73 rue Blaise Pascal, 93600 Aulnay-sous-Bois, France</p>
          <p>Téléphone : +33 1 48 68 03 03</p>
          <p>Email : contact@fritesdorees.fr</p>
        </Block>
        <Block title="Directeur de la publication">
          <p>La direction de Frites Dorées.</p>
        </Block>
        <Block title="Hébergeur">
          <p>Le présent site est hébergé par un prestataire professionnel. Les informations sont disponibles sur demande.</p>
        </Block>
        <Block title="Propriété intellectuelle">
          <p>L'ensemble des contenus présents sur ce site (textes, images, logos, charte graphique) sont la propriété de Frites Dorées ou de ses partenaires, et sont protégés par le droit français et international. Toute reproduction, représentation ou diffusion est soumise à autorisation préalable.</p>
        </Block>
        <Block title="Marques partenaires">
          <p>Les marques citées (Ulaş, Lamb Weston, Lutosa, Colona, Factory, Nubi, The Cheesecake Factory Bakery, Daim, Président, Ligueil, etc.) sont la propriété de leurs détenteurs respectifs et apparaissent à des fins d'information commerciale sur notre catalogue.</p>
        </Block>
      </section>
    </main>
  );
}

export function Privacy() {
  useDocumentMeta({
    title: "Politique de confidentialité",
    description: "Données collectées, finalité du traitement, conservation, droits RGPD et cookies sur le site Frites Dorées.",
    canonicalPath: "/confidentialite",
  });
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main data-testid="privacy-page" className="bg-[#050505]">
      <PageHeader kicker="Politique de confidentialité" title="Confidentialité" />
      <section className="px-6 md:px-10 lg:px-14 py-16 max-w-3xl space-y-8 text-zinc-300 font-body leading-relaxed">
        <Block title="Responsable du traitement">
          <p>Frites Dorées, 55-73 rue Blaise Pascal, 93600 Aulnay-sous-Bois. Contact : contact@fritesdorees.fr.</p>
        </Block>
        <Block title="Données collectées">
          <p>Dans le cadre de votre demande de contact, de devis ou de catalogue, nous collectons : nom, société, email, téléphone, numéro SIRET (facultatif), type d'activité, nombre de sites, volume d'achats et zone de livraison estimés (facultatifs), ainsi que le contenu de votre message. Pour la sécurité du formulaire et le suivi de la demande, nous enregistrons aussi la page d'origine, le type de navigateur et d'appareil, le pays de connexion, la date de la demande et votre acceptation de la présente politique. Une référence de type FD-AAAAMMJJ-XXXX est attribuée à chaque demande.</p>
        </Block>
        <Block title="Finalité et base légale">
          <p>Les données ne sont utilisées que pour : répondre à votre demande, établir un devis, ouvrir votre compte professionnel et, le cas échéant, vous transmettre des offres commerciales adaptées à votre activité. Le traitement repose sur les mesures précontractuelles prises à votre demande et sur notre intérêt légitime à développer une relation commerciale avec des professionnels. Le formulaire est protégé contre les envois automatisés (vérification anti-robot).</p>
        </Block>
        <Block title="Destinataires et sous-traitants">
          <p>Vos données sont destinées aux équipes commerciales de Frites Dorées. Elles transitent par nos prestataires techniques : Cloudflare (hébergement du site, traitement du formulaire et vérification anti-robot), Resend (envoi de l'email transmettant votre demande à notre équipe) et Microsoft 365 (messagerie de réception). Certains de ces prestataires peuvent traiter des données en dehors de l'Union européenne, dans le cadre de garanties appropriées (clauses contractuelles types). Vos données ne sont ni vendues ni cédées à des tiers.</p>
        </Block>
        <Block title="Durée de conservation">
          <p>Si votre demande n'aboutit pas à une relation commerciale, vos données sont conservées 3 ans à compter du dernier contact. En cas de relation commerciale, elles sont conservées pendant toute sa durée, puis archivées selon les obligations légales comptables (10 ans).</p>
        </Block>
        <Block title="Vos droits">
          <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition, de limitation et de portabilité sur vos données. Pour exercer ces droits : contact@fritesdorees.fr. Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la CNIL (www.cnil.fr).</p>
        </Block>
        <Block title="Cookies">
          <p>Le site utilise des cookies techniques nécessaires à son fonctionnement et des cookies analytiques pour mesurer l'audience. Vous pouvez paramétrer votre navigateur pour refuser les cookies.</p>
        </Block>
      </section>
    </main>
  );
}

export function Terms() {
  useDocumentMeta({
    title: "Conditions d'utilisation",
    description: "Objet, accès, clientèle exclusivement B2B, responsabilité et droit applicable — conditions d'utilisation du site Frites Dorées.",
    canonicalPath: "/cgu",
  });
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main data-testid="terms-page" className="bg-[#050505]">
      <PageHeader kicker="Conditions d'utilisation" title="Conditions d'utilisation" />
      <section className="px-6 md:px-10 lg:px-14 py-16 max-w-3xl space-y-8 text-zinc-300 font-body leading-relaxed">
        <Block title="Objet">
          <p>Le présent site a pour objet de présenter l'activité de Frites Dorées, son catalogue de produits et de permettre à des professionnels de la restauration de faire une demande de devis B2B.</p>
        </Block>
        <Block title="Accès au site">
          <p>Le site est accessible librement aux professionnels. Aucune vente en ligne n'est proposée. Toute commande passe par un expert Frites Dorées et une ouverture de compte préalable.</p>
        </Block>
        <Block title="Clientèle">
          <p>Frites Dorées distribue exclusivement à des professionnels de la restauration (snacks, fast-foods, kebabs, pizzerias, food trucks, dark kitchens, franchises, grossistes). Aucune vente aux particuliers.</p>
        </Block>
        <Block title="Responsabilité">
          <p>Les informations sont fournies à titre indicatif. Les fiches techniques détaillées des produits sont communiquées par votre expert commercial sur simple demande.</p>
        </Block>
        <Block title="Droit applicable">
          <p>Les présentes conditions sont régies par le droit français. Tout litige sera soumis au Tribunal compétent du lieu du siège de Frites Dorées.</p>
        </Block>
      </section>
    </main>
  );
}

const Block = ({ title, children }) => (
  <div>
    <h2 className="font-display text-2xl md:text-3xl uppercase tracking-tight mb-3 text-[#FFC300]">{title}</h2>
    <div className="space-y-2">{children}</div>
  </div>
);
